define([
	"dojo/_base/declare",
	"csi/reflection",
	"csi/table/Copy"
], function(declare,reflection,Copy) {

	return declare(Copy, {
		constructor: function(/*Object*/params) {
			// summary: setup parent parameters for copy
			this.m_urlParent = this.m_aSources[0].__Parent__;
			this.m_idAttrParent = "Samples";
			this.m_relation = reflection.getRelation(this.getParent(), this.m_idAttrParent);
		},

		onCreatePopup: function(/*csi.view.Widget*/view) {
			view.defView.removeField("ProductColor");
			view.defView.removeField("ProductSize");
			this.inherited(arguments);
		}
	});
});
